import React, { useState } from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@material-ui/core";
import Extension from "@material-ui/icons/Extension";
import SmartToy from "@mui/icons-material/SmartToy";
import AutoFixHigh from "@mui/icons-material/AutoFixHigh";
import { useChannelPlugins } from "../components/ChannelIcon";
import { app as appUI } from "@markedesk/plugin-sdk/ui";

const iconMap = { Extension, SmartToy, AutoFixHigh };

/**
 * Itens de menu lateral declarados por plugins (slot "sidebar-menu").
 *
 * Cada action com slot sidebar-menu vira um item de navegação. Ao clicar,
 * abre o painel do plugin (routePath + endpoint) num modal full — sem precisar
 * criar rota React nova. Renderiza nada se nenhum plugin declarar o slot.
 */
export default function PluginSidebarItems({ collapsed }) {
  const plugins = useChannelPlugins();
  const [panel, setPanel] = useState(null); // { title, src }

  const items = [];
  for (const plugin of plugins) {
    for (const action of plugin.provides?.actions || []) {
      if (action.slot === appUI.slots.SIDEBAR_MENU) {
        items.push({ ...action, plugin });
      }
    }
  }

  if (items.length === 0) return null;

  const openPanel = (action) => {
    if (!action.plugin.routePath) return;
    const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
    const ep = (action.endpoint || "").startsWith("/") ? action.endpoint : `/${action.endpoint || ""}`;
    setPanel({ title: action.label, src: `${backendUrl}${action.plugin.routePath}${ep}` });
  };

  return (
    <>
      {items.map((action) => {
        const IconComp = iconMap[action.icon] || Extension;
        return (
          <ListItem button key={`${action.plugin.id}-${action.id}`} onClick={() => openPanel(action)}>
            <ListItemIcon><IconComp /></ListItemIcon>
            {!collapsed && <ListItemText primary={action.label} />}
          </ListItem>
        );
      })}

      <Dialog open={!!panel} onClose={() => setPanel(null)} maxWidth="lg" fullWidth>
        <DialogTitle>{panel?.title}</DialogTitle>
        <DialogContent dividers style={{ padding: 0 }}>
          {panel && (
            <iframe
              title={panel.title || "Plugin"}
              src={panel.src}
              style={{ width: "100%", height: "70vh", border: 0, display: "block" }}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPanel(null)} color="primary">Fechar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
